// extracted by mini-css-extract-plugin
export var container = "NewsSection-module--container--Efhz8";
export var section = "NewsSection-module--section--SjKgJ";
export var maxContent = "NewsSection-module--maxContent--JeVjw";
export var content = "NewsSection-module--content--khVaU";
export var title = "NewsSection-module--title--nMNNc";
export var dateWrapper = "NewsSection-module--dateWrapper--MlktV";
export var date = "NewsSection-module--date--e5iDZ";
export var trap = "NewsSection-module--trap--UCS6K";
export var trapWrapper = "NewsSection-module--trapWrapper--hfKZP";